export default "__VITE_ASSET__DsUCOgmK__"